import Common from './common.js';

const Articles = (function () {
  /**
   * Filters array of articles by given value (case insensitive)
   * @param {unknown{}[]} articles
   * @param {string} value
   * @param {'cs'|'en'} lang
   * @returns {unknown{}[]}
   */
  function findArticles (articles, value, lang) {
    const values = value.split(' ');

    return articles.filter(article => {
      let countSuccessfulTests = 0;

      const keywords = getKeywords(article, lang);

      values.forEach(value => {
        const regex = new RegExp(`^${Common.toCode(value)}`);

        for (let i = 0; i < keywords.length; i++) {
          if (regex.test(keywords[i])) {
            countSuccessfulTests++;
            return;
          }
        }
      });

      return countSuccessfulTests === values.length;
    });
  }

  /**
   * Gets keywords from article
   * @param {unknown{}} article
   * @param {'cs'|'en'} lang
   * @returns {string[]}
   */
  function getKeywords (article, lang) {
    const keys = [`title.${lang}`, 'author.firstName', 'author.lastName'];
    const keywords = [];

    keys.forEach(key => {
      if (key.includes('.')) {
        keywords.push(...Common.toCode(article[key.split('.')[0]][key.split('.')[1]]).split(' '));
      } else {
        keywords.push(...Common.toCode(article[key]).split(' '));
      }
    });

    return Common.unique(keywords);
  }

  /**
   * Gets photogallery from article
   * @param {unknown{}} article
   */
  function getPhotogallery (article) {
    const matchesCs = article.content.cs
      ? [...article.content.cs.matchAll(/!\[[^\]]+\]\((p[0-9]+)\)/g)]
      : [];

    const matchesEn = article.content.en
      ? [...article.content.en.matchAll(/!\[[^\]]+\]\((p[0-9]+)\)/g)]
      : [];

    const photogallery = [
      ...matchesCs.map(match => match[1]),
      ...matchesEn.map(match => match[1]),
    ];

    return Common.unique(photogallery);
  }

  return {
    findArticles,
    getKeywords,
    getPhotogallery,
  };
})();

export default Articles;
